import { render, staticRenderFns } from "./drawer_for_vue_core_video_player.vue?vue&type=template&id=1cdc0332&scoped=true&"
import script from "./drawer_for_vue_core_video_player.vue?vue&type=script&lang=js&"
export * from "./drawer_for_vue_core_video_player.vue?vue&type=script&lang=js&"
import style0 from "./drawer_for_vue_core_video_player.vue?vue&type=style&index=0&id=1cdc0332&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdc0332",
  null
  
)

export default component.exports